import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { finalize, map } from 'rxjs';
import { CHANGE_PASSWORD_ROUTE } from '@/app/core/auth/auth-http.utils';
import { AuthService } from '@/app/core/auth/auth.service';
import { LoadingService } from '@/app/core/services/loading/loading.service';

/**
 * Protege rutas del área admin.
 * Si no hay sesión activa, redirige al login.
 * Si hay cambio de contraseña pendiente, redirige a /auth/change-password.
 */
export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const loadingService = inject(LoadingService);

  if (!authService.getToken()) {
    return router.createUrlTree(['/auth/sign-in']);
  }

  loadingService.show();

  return authService.checkStatus().pipe(
    map((ok) => {
      if (!ok) return router.createUrlTree(['/auth/sign-in']);
      if (authService.requiresPasswordChange()) {
        return router.createUrlTree([CHANGE_PASSWORD_ROUTE]);
      }
      return true;
    }),
    finalize(() => loadingService.hide())
  );
};
